<template>
  <PlanSegmentedControl
    v-if="showsPreview"
    :segments="previewSegments"
    :styles="segmentStyles"
    data-test="payment-provider-toggle-preview"
  />
</template>

<script>
import CardText from "%/dynamic-component-editor/options/card-text";
import AppStoreText from "%/dynamic-component-editor/options/app-store-text";
import GooglePlayText from "%/dynamic-component-editor/options/google-play-text";
import DiscountText from "%/dynamic-component-editor/options/discount-text";
import PlanSegmentedControl from "%/dynamic-component-editor/standard-components/plan-sheet/PlanSegmentedControl.vue";
import { PlanSegmentedControlMixin } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-segmented-control-mixin";
import { PROVIDERS } from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

// Card vs store rail picker. Only a store app can take a store payment, so the web
// renders nothing; the canvas previews it (unless the sheet forces a provider) so authors can style it.
export default {
  name: "PaymentProviderToggle",
  components: { PlanSegmentedControl },
  mixins: [PlanSegmentedControlMixin],
  elementPanelSettings: {
    displayName: "Payment Provider Toggle",
    displayIcon: "button",
    elementType: "element",
    tags: ["payments", "app store", "google play", "card", "toggle"],
  },
  options: [
    CardText,
    AppStoreText,
    GooglePlayText,
    DiscountText,
  ],
  computed: {
    showsPreview() {
      return this.editMode && (this.planSheet?.showsProviderToggle ?? true);
    },
    previewSegments() {
      return [
        { key: PROVIDERS.STRIPE, label: this.getOptionValue(CardText), selected: true },
        { key: PROVIDERS.APPLE, label: this.getOptionValue(AppStoreText), selected: false },
      ];
    },
  },
};
</script>
